/**
 * The notice an internet demo host carries on every screen — DECISIONS.md #49.
 *
 * **On a demo reachable from the internet, the danger is not the data in it but what a tester types
 * into it.** Everything in the record is synthetic (AGENTS.md §6), and a personnummer is refused at
 * the keyboard, but a clinician trying the note form will write the kind of note they write at work,
 * about the kind of patient they had this morning. On the box that would be a LAN and the hospital's
 * own records; on a cloud host it is patient data where it must never be. So the screen says so,
 * under the banner, before login and on every screen after it.
 *
 * **Compiled in, not configured at run time.** The bundle is built with the deployment it is for, by
 * the same build argument that selects the demo's Caddyfile, so a demo with a public certificate
 * cannot be built without this notice — and a box, built without the argument, never shows it.
 *
 * Under the banner rather than in it: the banner's height is what every sticky offset on the patient
 * and list screens is measured from (`--banner-height`), and its words are reserved (#42).
 */

import { useTranslation } from 'react-i18next'

/** Whether this bundle was built for an internet demo host. */
export function isInternetDemo(deployment: string | undefined): boolean {
  return deployment === 'internet-demo'
}

export function DeploymentNotice({
  deployment = import.meta.env.VITE_CONTINUUM_DEPLOYMENT,
}: {
  /** Injected by tests; the bundle's own value otherwise. */
  readonly deployment?: string | undefined
}) {
  const { t } = useTranslation('common')

  if (!isInternetDemo(deployment)) {
    return null
  }

  return (
    <p className="deployment-notice" role="note">
      {t('deployment.internetDemo')}
    </p>
  )
}
